import { styled } from '@teko/ds-desktop';
import React from 'react';
import { useBanners } from 'hooks';
import { getTrackingData } from '@teko/tracking';

export interface SideBannersProps {
  className?: string;
}
const Parent = styled.div`
  position: sticky;
  top: 96px;
  display: flex;
  justify-content: center;
`;
const Wrapper = styled.div`
  position: absolute;
  display: flex;
`;
const Middle = styled.div`
  min-width: 1264px;
  z-index: -1;
`;
const Banner = styled.div`
  width: 150px;
  height: 350px;
  z-index: 1040;
  @media (max-width: 1600px) {
    width: 60px;
    height: 140px;
  }
  @media (max-width: 1366px) {
    display: none;
  }
`;
const StyledImg = styled.img`
  cursor: pointer;
  object-fit: fill;
  width: 100%;
  transition: transform 0.4s;
  &:hover {
    transform: scale(1.05);
  }
`;

export const SideBanners: React.FC<SideBannersProps> = ({
  className,
}: SideBannersProps) => {
  const { banners: responseRightBanners } = useBanners(
    'right-sticky-banner-150x350',
  );
  const { banners: responseLeftBanners } = useBanners('sticky-banner-150x350');
  const leftBanner = responseLeftBanners?.[0];
  const rightBanner = responseRightBanners?.[0];

  if (!leftBanner && !rightBanner) return null;

  return (
    <Parent className={className}>
      <Wrapper>
        <Banner
          {...getTrackingData({
            regionName: 'leftStickBanner',
            isTrackContent: true,
          })}
        >
          {leftBanner && (
            <a href={leftBanner.targetPath}>
              <StyledImg src={leftBanner.image} />
            </a>
          )}
        </Banner>
        <Middle></Middle>
        <Banner
          {...getTrackingData({
            regionName: 'rightStickBanner',
            isTrackContent: true,
          })}
        >
          {rightBanner && (
            <a href={rightBanner.targetPath}>
              <StyledImg src={rightBanner.image} />
            </a>
          )}
        </Banner>
      </Wrapper>
    </Parent>
  );
};
